import { SortableFilter }          from './../common/sortable-filter';

export class TrainCycleSortableFilter extends SortableFilter {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-list/train-cycle-sortable-filter.ts